import Chip from "@mui/material/Chip";
import TableCell from "@mui/material/TableCell";
import Typography from "@mui/material/Typography";

export const openaiAssetRowCyIds = {
  organizationId: "openai-asset-organization-id",
  statusActive: "openai-asset-status-active",
  statusInactive: "openai-asset-status-inactive",
};

export interface OpenAIAssetRowData {
  orgId: string;
  orgName: string;
  status: string;
}

interface OpenAIAssetRowProps {
  data: OpenAIAssetRowData;
}

const OpenAIAssetRow = ({ data }: OpenAIAssetRowProps) => (
  <>
    <TableCell>
      <Typography variant="body2" component="span" data-cy="openai-asset-organization-id">
        {data.orgId}
      </Typography>
    </TableCell>
    <TableCell>
      <Typography variant="body2" component="span" data-cy="openai-asset-organization-name">
        {(data.orgName ?? "")
          .split("-")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(" ")}
      </Typography>
    </TableCell>
    <TableCell>
      {data.status === "active" ? (
        <Chip size="small" label="Active" color="success" data-cy="openai-asset-status-active" />
      ) : (
        <Chip size="small" label="Inactive" color="error" data-cy="openai-asset-status-inactive" />
      )}
    </TableCell>
  </>
);

export default OpenAIAssetRow;
